module.exports = __webpack_public_path__ + "img/62.ccd8cd9b.jpg";